module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/.deno/core-js@2.6.12/~/core-js/library/modules/_iterators.js
// module id = 35
// module chunks = 0